<template>
  <router-view />
</template>

<script lang="ts">
export default { name: 'App' };
</script>

<style scoped>
@import '~@jsonforms/vue-vuetify/lib/jsonforms-vue-vuetify.esm.css';
</style>
